const en_US = {
  'analyse.level1DistributionTitle': 'Best substations to trim',
  'analyse.level1TransmissionTitle': 'Best districts to trim',
  'analyse.level2DistributionCircuitTitle': 'Best circuits to trim',
  'analyse.level2TransmissionTitle': 'Best lines to trim',
  'analyse.level2TransmissionSegmentTitle': 'Best segments to trim',
  'analyse.level2TransmissionTreesTitle': 'Circuits by number of',
  'analyse.level2DistributionTitle': 'Best circuits to trim',
  'analyse.level2DistributionCircuitHazardTreesTitle':
    'Circuits by number of hazard trees',
  'analyse.level2DistributionCircuitTreesTitle': 'Circuits by number of',
  'analyse.level2DistributionHazardTreesTitle': '', // Unused?
  'analyse.level2DistributionTreesTitle': '', // Unused?
  'analysis.wildfireEncroachmentRisk': 'encroachment miles outside risk zone',
  'analysis.filterButton': 'Filters',
  'analysis.moreFiltersButton': 'More filters',
  'export.fileTypeCSV': 'CSV',
  'export.fileTypeXLS': 'Excel (.xls)',
  'export.optionsTitle': 'Choose format',
  'export.fileErrorMessage':
    'Something went wrong. Please contact your Overstory customer success manager.',
  'export.fileTooLarge':
    'You are trying to export too many records. Use filters to reduce your selection.',
  'export.downloadSuccessful': 'File downloaded successfully',
  'list.clearFilterButton': 'Clear all filters',
  'list.noResultsWithActiveFilters':
    'No results with the current active filters.',
  'list.noResultsForSelectedAnalysis':
    'No data available for the selected analysis.',
  'list.totalSpans': '{num, plural, one {# span} other {# spans}}',
  'list.level2DistributionCircuitTotalsLabel':
    '{num, plural, one {# circuit} other {# circuits}}',
  'list.level2TransmissionTotalsLabel':
    '{num, plural, one {# line} other {# lines}}',
  'list.level2TransmissionSegmentTotalsLabel':
    '{num, plural, one {# segment} other {# segments}}',
  'list.viewOnMapButton': 'View on map',
  'list.encroachmentAnalysisViewTitle': 'Analyze your network by',
  'list.fallInAnalysisViewTitle': 'Analyze your network by',
  'list.fallInHazardTreesCountLabel': 'Hazard trees',
  'list.priorityAnalysisViewTitle': 'Rank & view network by',
  'list.wildfirePriorityAnalysisViewTitle': 'Rank & view network by',
  'list.clearAnalysisViewTitle': 'Rank & view network by',
  'list.workloadAnalysisViewTitle': 'Rank & view network by',
  'list.encroachmentAnalysisView': 'Encroachment',
  'list.encroachmentAnalysisViewDescription':
    'Identify where trees are close to the line',
  'list.fallInHealthAnalysisView': 'Fall-in',
  'list.fallInHealthAnalysisViewDescription':
    'Identify where trees are most likely to fall on the line and where declining trees are',
  'list.priorityAnalysisView': 'Reliability',
  'list.reliabilityPriorityAnalysisView': 'Reliability', // only for customers with wildfire priority analyses
  'list.priorityAnalysisViewDescription':
    'Identify locations with high vegetation risk that are critical to your network',
  'list.wildfirePriorityAnalysisView': 'Wildfire',
  'list.wildfirePriorityAnalysisViewDescription':
    'Identify locations with high wildfire and vegetation risk',
  'list.clearAnalysisView': 'Clear',
  'list.clearAnalysisViewDescription':
    'Spans with no (or far away) detected trees in the right-of-way and do not have nearby strike trees',
  'list.workloadAnalysisView': 'Workload analysis',
  'list.criticalTreesInventoryView': 'Critical trees',
  'list.workloadAnalysisViewDescription':
    'Identify and quantify critical trees that need work',
  'list.rankBy': 'Objective',
  'list.groupBy': 'Group by',
  'list.groupByName': 'By {name}',
  'list.chooseObjective': 'Choose objective',
  'list.groupByLabel': 'Group by',
  'list.learnMore': 'Learn more',
  'list.fuelHazardScore': 'Fuel hazard score',
  'list.aboutHowRiskIsAggregated': 'about how risk is aggregated',
  'level3.distribution': 'Distribution',
  'level3.transmission': 'Transmission',
  'level3.overgrowthIndexLabel': 'Overgrowth index',
  'level3.healthIndexLabel': 'Health index',
  'level3.criticalRatingLabel': 'Critical',
  'level3.highRatingLabel': 'High',
  'level3.mediumRatingLabel': 'Medium',
  'level3.lowRatingLabel': 'Low',
  'level3.minorRatingLabel': 'Minor',
  'level3.noneRatingLabel': 'None',
  'level3.unknownRatingLabel': 'Unknown',
  'level3.spanLengthField': '{length, plural, one {# mile} other {# miles}}',
  'level3.spanLengthFieldMetric':
    '{length, plural, one {# kilometer} other {# kilometers}}',
  'level3.level1Distribution': 'Substation',
  'level3.level1DistributionDivision': 'Division',
  'level3.level2DistributionCircuit': 'Circuit',
  'level3.level1Transmission': 'District',
  'level3.level2Transmission': 'Line',
  'level3.level2TransmissionSegment': 'Segment',
  'level3.hazardTreesCount': 'Hazard tree count',
  'level3.decliningTreesCount': 'Declining tree count',
  'level3.strikeTreesCount': 'Strike tree count',
  'level3.criticalTreesCount': 'Critical tree count',
  'search.placeholder': 'Search poles, spans, addresses',
  'search.noResults': 'Nothing found with this term.',
  'search.noResultsWithActiveFilters':
    'No results with the current active filters.',
  'search.clearFilterButton': 'Clear all filters',
  'search.groupLabel.Spans': 'Spans',
  'search.groupLabel.Poles': 'Poles',
  'search.groupLabel.Addresses': 'Addresses',
  'search.groupLabel.Coordinates': 'Coordinates',
  'search.groupLabel.SpansInternal': '[Internal] Overstory ID',
  'filter.showResults': 'Show results',
  'filter.keepTypingToNarrow':
    'Too many matches to show at once. Keep typing to narrow the results.',
  'filter.clear': 'Clear',
  'filter.title': 'Filter',
  'filter.spanCountTooltip': '{count} spans match the current filter',
  'filter.totalSpansTooltip': 'Total spans in Overstory',
  'filter.of': 'of',
  'filter.analysisDateTitle': 'Analysis Date',
  'filter.lastAnalyzedLabel': 'Last analyzed',
  'filter.allYearsPlaceholder': 'All years',
  'filter.otherPlaceholder': 'Other',
  'filter.activitySection': 'Activity',
  'filter.networkSection': 'Network',
  'filter.networkTypeSection': 'Network type',
  'filter.allNetworkOption': 'All',
  'filter.distributionOption': 'Distribution only',
  'filter.transmissionOption': 'Transmission only',
  'filter.distributionSection': 'Distribution',
  'filter.transmissionSection': 'Transmission',
  'filter.vegetationRiskSection': 'Vegetation risk',
  'filter.riskAndVegetationSection': 'Risk & Vegetation',
  'filter.spanSection': 'Spans',
  'filter.workYearSingleYearQuickSelectLabel': 'only',
  'filter.level1DistributionLabel': 'Substations',
  'filter.level1DistributionPlaceholder': 'All substations',
  'filter.level1DistributionDivisionLabel': 'Divisions',
  'filter.level1DistributionDivisionPlaceholder': 'All divisions',
  'filter.level1TransmissionLabel': 'Districts',
  'filter.level1TransmissionPlaceholder': 'All districts',
  'filter.level2DistributionCircuitLabel': 'Circuits',
  'filter.level2DistributionCircuitPlaceholder': 'All circuits',
  'filter.level2TransmissionLabel': 'Lines',
  'filter.level2DistributionLabel': 'Circuits',
  'filter.level2DistributionPlaceholder': 'All circuits',
  'filter.level2TransmissionPlaceholder': 'All lines',
  'filter.level2TransmissionSegmentLabel': 'Segments',
  'filter.level2TransmissionSegmentPlaceholder': 'All segments',
  'filter.level2TransmissionSegment': 'Segment',
  'filter.overgrowthIndexLabel': 'Overgrowth index',
  'filter.encroachmentRiskLabel': 'Encroachment levels',
  'filter.encroachmentRiskPlaceholder': 'All levels',
  'filter.minEncroachmentRatingLabel': 'Min index',
  'filter.maxEncroachmentRatingLabel': 'Max index',
  'filter.phaseSystemLabel': 'Phase system',
  'filter.spanTypeLabel': 'Span type',
  'filter.singlePhaseSpanTypeLabel': 'Single phase',
  'filter.twoPhaseSpanTypeLabel': 'Two phase',
  'filter.threePhaseSpanTypeLabel': 'Three phase',
  'filter.treeSpeciesLabel': 'Contains tree species',
  'filter.treeSpeciesPlaceholder': 'All tree species',
  'filter.voltageLabel': 'Voltage',
  'filter.voltagePlaceholder': 'All voltages',

  'filter.hazardTreesTitle': 'Hazard trees',
  'filter.hazardTreesLabel': 'Only show spans with hazard trees',
  'filter.strikeTreesTitle': 'Strike trees',
  'filter.strikeTreesLabel': 'Only show spans with strike trees',
  'filter.criticalTreesTitle': 'Critical trees',
  'filter.criticalTreesLabel': 'Only show spans with critical trees',
  'filter.encroachmentTypeLabel': 'Encroachment type',
  'filter.encroachmentTypePlaceholder': 'All types',
  'filter.allEncroachmentTypesLabel': 'All types',
  'filter.withOverhangLabel': 'With overhang',
  'filter.withoutOverhangLabel': 'Without overhang',

  'widget.summary.level2DistributionCircuitTotalsLabel':
    '{num, plural, one {# circuit} other {# circuits}}',
  'widget.summary.level2TransmissionSegmentTotalsLabel':
    '{num, plural, one {# segment} other {# segments}}',
  'widget.summary.level1DistributionSubstationTotalsLabel':
    '{num, plural, one {# substation} other {# substations}}',
  'widget.summary.level1TransmissionSegmentTotalsLabel':
    '{num, plural, one {# division} other {# divisions}}',
  'widget.summary.level1DistributionVMUTotalsLabel':
    '{num, plural, one {# VMU} other {# VMUs}}',
  'widget.trees.metricCount': 'Count',
  'widget.trees.metricAvgPerMile': 'Avg. per mile',
  'widget.trees.metricAvgPerKilometer': 'Avg. per kilometer',
  'widget.hazardTreeTitle': 'Reduce fall-in outages',
  'widget.treesTitle': 'Monitor fall-in',
  'widget.fallIn.hazardTreesTitle': 'Total hazard trees',
  'widget.fallIn.decliningTreesTitle': 'Total declining trees',
  'widget.fallIn.strikeTreesTitle': 'Total strike trees',
  'widget.fallIn.hazardTreesDropdownLabel': 'hazard trees',
  'widget.fallIn.decliningTreesDropdownLabel': 'declining trees',
  'widget.fallIn.strikeTreesDropdownLabel': 'strike trees',
  'map.tooltip.horizontalDistanceToLine': 'H. dist to line',
  'map.tooltip.verticalDistanceToLine': 'V. dist to line',
  'map.tooltip.worktype': 'Work type',
  'map.geolocation.permissionError':
    'Overstory does not have the permission to use your location.',
  'map.geolocation.otherError':
    'We could not get your current location. Please try again.',
  'map.modal.hazardTreeTitle': 'Hazard tree',
  'map.layerManager.treesDescription': 'Select which type of trees to include',
  'map.layerManager.hazardTreesTitle': 'Hazard trees',
  'map.layerManager.decliningTreesTitle': 'Declining trees',
  'map.layerManager.strikeTreesTitle': 'Strike trees',
  'map.layerManager.worktypeAnalysisTitle': 'Work type',
  'map.layerManager.workStatusTitle': 'Work status',
  'map.layerManager.title': 'Layers',
  'map.legend.hazardTreesTitle': 'Hazard trees',
  'map.legend.decliningTreesTitle': 'Declining trees',
  'map.legend.strikeTreesTitle': 'Strike trees',
  'map.legend.learnMoreAbout': 'Learn more about',
  'map.legend.fallIn.title': 'Fall-in',
  'map.legend.fallIn.help.link':
    'https://help.overstory.com/en/articles/10006672-fall-in-health-risk',
  'map.legend.fallIn.help.linkText': 'Fall-in & health',
  'program.defaultName': 'Cycle Schedule',
  'program.status.in_progress': 'In Progress',
  'program.status.completed': 'Completed',
  'program.status.todo': 'To work',
  'program.status.to_audit': 'To audit',
  'spanMapPopover.more': 'More',
  'spanMapPopover.addActivity': 'Add activity',
  'customList.project': 'Project',
  'customList.seeAll': 'See all',
  'projectDemo.projectsPlaceholder': 'Create a project to get started.',
  'projectDemo.setProjectScope': 'Set project scope',
  'projectDemo.scopeHint':
    'Add rules to define which spans should be included in scope',
  'projectDemo.addCondition': 'Add condition',
  'projectDemo.expectedOutcomes': 'Expected outcomes',
  'projectDemo.expectedVegetationSaidi': 'Expected vegetation SAIDI',
  'projectDemo.progress': 'Progress',
  'projectDemo.completed': 'Completed:',
  'projectDemo.remaining': 'Left:',
  'projectDemo.riskBuyDown': 'Encroachment risk buy down',
  'projectDemo.progressTooltip':
    '{completed, plural, one {# span} other {# spans}} completed, {remaining, plural, one {# span} other {# spans}} left',
  'projectDemo.noSpansAtRating': 'No spans at this rating in this scope',
  'projectDemo.noSpans': 'No spans in scope.',
  'projectDemo.confirmHintName': 'Enter a project name to continue',
  'projectDemo.confirmHintScope': 'Add at least one condition to continue',
  'projectDemo.confirmHintIncomplete': 'Complete every condition to continue',
  'projectDemo.confirmHintLoading': 'Checking the scope…',
  'projectDemo.confirmHintNoSpans':
    'Widen the scope to include at least one span',
  'projectDemo.sync': 'Sync',
  'projectDemo.syncPreparing': 'Preparing worklogs…',
  'projectDemo.syncPushing': 'Sending worklogs to Fulcrum…',
  'projectDemo.syncPulling': 'Fetching updates from Fulcrum…',
  'projectDemo.syncSaving': 'Saving changes…',
  'projectDemo.syncOtherProject': 'Another project is syncing with Fulcrum…',
  'projectDemo.syncStatusUnavailable':
    'Could not check sync progress. Reconnecting…',
  'projectDemo.syncError': 'Could not sync with Fulcrum. Please try again.',
  'projectDemo.lastSynced': 'Last synced to Fulcrum:\n{date} at {time}',
  'projectDemo.projectNotFound': 'This project could not be found.',
  'projectDemo.projectsLoadError': 'Projects could not be loaded.',
  'projectDemo.resetTitle': 'Reset demo state',
  'projectDemo.resetDescription':
    'Removes the demo state of {client}: its work logs, its projects, and every record and project in its Fulcrum form.',
  'projectDemo.resetWarning':
    'This cannot be undone. Records and projects are removed from the Fulcrum Vegetation Management App.',
  'projectDemo.resetPickClient': 'Pick a client to reset.',
  'projectDemo.resetButton': 'Reset demo state',
  'projectDemo.resetConfirmTitle': 'Reset the demo state?',
  'projectDemo.resetConfirmBody':
    'This removes every work log and project of {client}, and empties its Fulcrum form. It cannot be undone.',
  'projectDemo.resetConfirm': 'Reset',
  'projectDemo.resetCancel': 'Keep the data',
  'projectDemo.resetResultTitle': 'What the reset removed',
  'projectDemo.resetWorkLogs': 'Work logs',
  'projectDemo.resetPlans': 'Projects',
  'projectDemo.resetRecords': 'Fulcrum records',
  'projectDemo.resetProjects': 'Fulcrum projects',
  'projectDemo.resetDone': 'The demo state is clear.',
  'projectDemo.resetPartial':
    'Part of the reset did not finish. Read the detail below, then try again or ask for help.',
  'projectDemo.resetFailed':
    'The reset did not run. Try again, or ask for help with this message: {detail}',
  'customList.addToList': 'Add to project',
  'customList.allLists': 'All projects',
  'customList.lists': 'Projects',
  'customList.newList': 'New project',
  'customList.noListsAvailable': 'No projects available.',
  'customList.overviewZeroStateTitle': 'Create your first project',
  'customList.createList': 'Create project',
  'customList.creatingList': 'Creating project...',
  'customList.createListSuccess': 'Project created successfully!',
  'customList.creatingListMessage':
    "We're creating your new project. Please wait.",
  'customList.addingToList': 'Adding to project...',
  'customList.addingToListMessage':
    "We're adding selected spans to the project.",
  'customList.addedSpansToListTitle': 'Successfully added to the project.',
  'customList.spansAddedToListDescription':
    '{count, number} spans added to <a>{listName}</a> project',
  'customList.newListDescription': 'New project',
  'customList.addToNewList': 'Add to new project',
  'customList.name': 'Project name',
  'customList.namePlaceholder': 'Project name',
  'customList.nameRequired': 'Project name is required',
  'customList.description': 'Project description (optional)',
  'customList.descriptionPlaceholder': 'Description',
  'customList.errorAddingToList': 'Error adding to project',
  'customList.listDetails': 'Project details',
  'customList.deleteList': 'Delete project',
  'customList.removeFrom': 'Remove from',
  'customList.removeFromListError':
    'Error removing span from project. Please try again.',
  'customList.deleteError': 'Error deleting project',
  'customList.removeSpanError': 'Error removing span from project',
  'customList.deleteConfirmationMessage':
    'Are you sure you want to permanently delete this project for everyone?',
  'customList.getStarted':
    'Add spans to projects to easily track, share & return to later.',
  'customList.deleteErrorMessage': 'There was an error deleting the project.',
  'customList.notFound': 'Project not found.',
  'customList.noListItems': 'No spans in this project.',
  'customList.scopeHeader': "What's the scope?",
  'customList.addSpansDescription':
    'Add spans to this project to easily track, share & return to later.',
  'customList.addSpans': 'Add spans',
  'customList.editList': 'Edit project',
  'customList.editError': 'Error editing project',
  'customList.editErrorMessage': 'There was an error editing the project.',
  'customList.loadError':
    'Error loading project. Please contact your Overstory customer success manager.',
  'customList.copyLinkMessage': 'Send a link to this project',
  'customList.addToListDisabled':
    'Apply filters to focus on a specific set of spans.',
  'customList.addALotToListAreYouSure':
    'Are you sure you want to add {count, number} spans to a project?',
  'customList.addALotToListMessage':
    'Consider applying more filters to focus on a more actionable set of spans.',
  'customList.addALotToListConfirm': 'Add all spans to project',
  'customList.addALotToListCancel': 'Refine selection',
  'customList.steps': 'Step {onStep} of {ofStep} - {action}',
  'customList.stepActionFilterToAdd':
    "Filter to the spans you'd like to add to this project",
  'customList.addToProject': 'Add to project',
  'customList.filterDisabledNoSpans':
    'Add spans to this project to enable filtering',
  'customList.uploadCsv': 'Upload CSV',
  'customList.errorLoadingLists': 'Error loading projects',
  'customList.createProjectFromCsv': 'Create Project from CSV',
  'customList.csvFileRequired': 'CSV file is required',
  'customList.level2HeaderRequired': 'Level 2 header is required',
  'customList.level3HeaderRequired': 'Level 3 header is required',
  'customList.csvFileLabel': 'CSV File',
  'customList.selectCsvFile': 'Select CSV file',
  'customList.csvUploadDescription':
    'Upload a CSV file with two columns of data: level2 (e.g., circuit) and level3 (Overstory ID). The columns should have titles; input those column titles below. All the spans in your CSV will be added to a new project.',
  'customList.level2ColumnName': 'Level 2 Column Name',
  'customList.level2Placeholder': 'level2',
  'customList.level3ColumnName': 'Level 3 Column Name',
  'customList.level3Placeholder': 'level3',
  'customList.DataMessage':
    'Data based on the latest available data for each span.',
  'customList.removeFromProject': 'Remove from this project',
  'customList.removeFromProjectConfirmationTitle': 'Remove from project',
  'customList.removeFromProjectConfirmationMessage':
    'Are you sure you want to remove {count} spans from this project?',
  'customList.removeFromProjectConfirmationButton': 'Remove spans',
  'customList.removeFilteredFromListSuccess':
    '{count} spans removed from {projectName} project',
  'customList.removeFilteredFromListError':
    'Error removing from project. Please try again.',
  'worklog.activityDeletingTitle': 'Delete activity',
  'worklog.activityDeletingMessage': 'Deleting activity...',
  'worklog.activityDeleteSuccess': 'Activity deleted successfully',
  'worklog.activitySaveError': 'Activity could not be saved',
  'worklog.activityDeleteError': 'Activity could not be deleted',
  'worklog.addActivity': 'Add activity',
  'worklog.editActivity': 'Edit activity',
  'worklog.adding': 'Adding activity...',
  'worklog.addingMessage': 'We are adding the activity to this span.',
  'worklog.addSuccess': 'Activity added successfully',
  'worklog.addSuccessMessage': 'The activity has been added.',
  'worklog.updating': 'Updating activity...',
  'worklog.updatingMessage': 'We are updating the activity for this span.',
  'worklog.updateSuccess': 'Activity updated successfully',
  'worklog.updateSuccessMessage': 'The activity has been updated.',
  'worklog.activityDeleteConfirmation':
    'Are you sure you want to delete this field entry?',
  'worklog.dateOfCompletion': 'Date of completion',
  'worklog.dateOfInspection': 'Date of inspection',
  'worklog.datePlaceholder': 'Select date and time',
  'worklog.notesLabel': 'Notes (Optional)',
  'worklog.notesPlaceholder': 'Enter notes here...',
  'worklog.syncedFromSource': 'Synced from {source} on {date}',
  'worklog.program': 'Program: {name}',
  'action.error': 'Error',
  'action.genericError':
    'Either try again or reach out to your Overstory point of contact.',
  'action.staleConflict':
    'This was updated elsewhere since you opened it. Please reload the page and try again.',
  'action.notFound': 'The requested resource could not be found.',
  'action.cancel': 'Cancel',
  'action.close': 'Close',
  'action.confirm': 'Confirm',
  'action.edit': 'Edit',
  'action.delete': 'Delete',
  'action.deleteSuccessMessage': '"{item}" was deleted successfully!',
  'action.save': 'Save',
  'action.editError': 'Edits could not be saved',
  'action.success': 'Success',
  'action.loading': 'Loading...',
  'action.copyLink': 'Share',
  'action.learnMore': 'Learn more',
  'action.ok': 'OK',
  'action.discard': 'Discard',
  'action.createScenario': 'Create scenario',
  'scenarioCard.openScenario': 'Open scenario',
  'scenarios.listHeader': 'Scenarios',
  'scenarioMap.legend.title': 'Next work year',
  'scenarioMap.legend.groupsByYear': '{year} {groups}',
  'scenarioMap.legend.otherGroups': 'Other {groups}',
  'action.exitEditMode': 'Exit edit mode',
  'action.saving': 'Saving...',
  'action.saved': 'Saved',
  'action.saveChanges': 'Save changes',
  'action.savingChanges': 'Saving changes',
  'action.reset': 'Reset',
  'action.settings': 'Settings',
  'action.editNameDescription': 'Edit name & description',
  'action.programSettings': 'Program settings',
  'action.archiveScenario': 'Archive this scenario',
  'action.archiveScenarioConfirmTitle': 'Do you want to archive this scenario?',
  'action.archiveScenarioConfirmMessage':
    'This scenario will be archived and can no longer be edited.',
  'action.archive': 'Archive',
  'action.unarchiveScenario': 'Unarchive this scenario',
  'action.unarchiveScenarioConfirmTitle':
    'Do you want to unarchive this scenario?',
  'action.unarchiveScenarioConfirmMessage':
    'This scenario will be moved back to draft status and can be edited again.',
  'action.unarchive': 'Unarchive',
  'action.export': 'Export {thing}',
  'action.exportGeneral': 'Export',
  'action.importGeneral': 'Import',
  'action.select': 'Select',
  'action.next': 'Next',
  'action.back': 'Back',
  'action.map': 'Map',
  'action.list': 'List',
  'action.summary': 'Summary',
  'analysisList.tab.summary': 'Summary',
  'analysisList.tab.spans': 'Spans',
  'action.create': 'Create',
  'action.unsavedChanges': 'Unsaved changes',
  'action.unsavedChangesMessage':
    'You started editing. Are you sure you want to leave this page?',
  'action.copyLinkSuccess': 'Link copied to clipboard',
  'action.actions': 'Actions',
  'action.readMore': 'Read more',
  'action.clear': 'Clear',
  'action.publish': 'Publish',
  'action.publishRelease': 'Publish release',
  'action.publishReleaseIntro':
    'Choose how you would like to publish this release:',
  'action.publishReleaseLoadFailed':
    'Failed to load the published releases for this scan. Try again.',
  'action.publishReleaseNoPublishedIntro':
    "There's no currently published release for this scan.",
  'action.publishReleaseNoPublishedInfo':
    "Once published, it will appear in the version dropdown customers use to view this scan's data.",
  'action.publishReleaseReplaceOption': 'Replace existing release',
  'action.publishReleaseReplaceTooltip':
    'If you wish to improve an existing release the customer already has access to, overwriting results.',
  'action.releaseToReplaceLabel': 'Pick which release to replace',
  'action.publishReleaseReplaceWarning':
    "You're about to replace an existing release.",
  'action.publishReleaseReplaceWarningDetail':
    'The customer will not be able to see the currently published state anymore.',
  'action.publishReleaseAddOption': 'Add as new release',
  'action.publishReleaseAddTooltip':
    "If you want the customer to be able to choose between what's currently published and this new release. For example, if the customer is planning work with an existing release and should not lose access to what's published.",
  'action.publishReleaseAddWarning': "You're about to add a release.",
  'action.publishReleaseAddWarningDetail':
    'The customer will be able to choose it alongside other existing releases from the version dropdown in the shipped product.',
  'action.publishReleaseNamePreview':
    'The new release will be published as "{name}".',
  'action.publishReleaseNamePreviewInherited':
    'The new release will be published as "{name}", inherited from the replaced release.',
  'action.publishReleaseNamePreviewNoName':
    'The new release will be published with the default display name.',
  'action.customerFacingNameLabel': 'Customer-facing name (optional)',
  'action.customerFacingNamePlaceholder':
    'Write the customer-facing name of the release here...',
  'action.releaseNameLabel': 'Release name (optional)',
  'action.releaseNamePlaceholder': 'e.g. 2026 — Mar',
  'action.renameRelease': 'Rename release {name}',
  'action.releaseRenameSucceeded': 'Release name updated.',
  'action.releaseNameTooLong':
    'Release name must be {max} characters or fewer.',
  'action.revokeRelease': 'Revoke release {name}',
  'action.revokeReleaseWarning':
    "You're about to revoke this release. The customer will no longer be able to see it. This action cannot be undone.",
  'action.revoke': 'Revoke',
  'action.archiveRelease': 'Archive release {name}',
  'action.archiveReleaseWarning':
    "You're about to archive this draft. It won't be published or become visible to the customer. This action cannot be undone.",
  'action.releasePublishSucceeded': 'Release is now published.',
  'action.releasePublishReplaceSucceeded':
    'Release is now published and the replaced one revoked.',
  'action.releasePublishConflict':
    'A release was updated elsewhere — refresh and try again.',
  'action.releaseRevokeSucceeded': 'Release is now revoked.',
  'action.releaseArchiveSucceeded': 'Release is now archived.',
  'action.releasesArchiveSucceeded': '{count} releases archived.',
  'action.releasesAllAlreadyArchived':
    'These releases were already archived — no change needed.',
  'action.releasesArchivePartlyAlready':
    '{count} releases archived. {alreadyCount} had already been archived.',
  'action.bulkRevokeStaleDraft':
    'A selected release is no longer a draft — refresh and try again.',
  'action.bulkArchiveReleases': 'Archive {count} releases',
  'action.bulkArchiveReleasesWarning':
    "You're about to archive these drafts. They won't be published or become visible to the customer. This action cannot be undone.",
  'release.selectedCount': '{count} selected',
  'release.selectAllDrafts': 'Select all drafts',
  'release.deliveryFilterLabel': 'Delivery',
  'release.deliveryFilterPlaceholder': 'Type a delivery identifier',
  'action.clearSelection': 'Clear',
  'action.releaseStatusFailed': 'Something went wrong. Try again.',
  'action.unpublish': 'Unpublish',
  'action.defaultErrorMessage':
    'Please refresh the page and try again, or contact your Overstory customer representative if you are still having issues.',
  'action.keepActiveScenario': 'Keep active scenario',
  'action.deleteScenario': 'Delete scenario',
  'action.deleteScenarioConfirmTitle': "Permanently delete ''{scenarioName}''?",
  'action.deleteScenarioConfirmMessage':
    'This scenario is visible to your whole team. If you might need it later, consider archiving it instead.',
  'action.deleteArchivedScenarioConfirmMessage':
    "This will permanently delete the scenario for your whole team. This action can't be undone.",
  'action.archiveInstead': 'Archive instead',
  'action.archiveScenarioModalTitle': "Archive ''{scenarioName}''?",
  'action.archiveScenarioModalMessage':
    'This scenario will no longer be editable. You can restore it at any time.',
  'meta.lastEditedDate': 'Last edited {date}',
  'noun.spans': 'spans',
  'noun.span': 'span',
  'noun.project': 'project',
  'noun.miles': 'miles',
  'noun.mile': 'mile',
  'noun.kilometers': 'kilometers',
  'noun.kilometer': 'kilometer',
  'noun.mile.short': 'mile',
  'noun.miles.short': 'miles',
  'noun.kilometer.short': 'km',
  'noun.kilometers.short': 'kms',
  'noun.network': 'Network',
  'programTable.headlineStatistic.estimatedCostTitle': 'Estimated cost',
  'programTable.headlineStatistic.riskTitle': 'Risk in scope',
  'programTable.headlineStatistic.riskTooltip':
    'Represents expected share of scanned network SAIFI from vegetation encroachment that is in-scope for this plan.',
  'programTable.headlineStatistic.wildfireRiskProgramTooltip':
    'Risk that is in scope within the area covered by the program, which may not be the same as the amount of risk reduced when work is completed. Wildfire risk is calculated by multiplying the likelihood metric (burnability per year) with consequence (value within 0.07 mi). <link>Learn more</link>',
  'programTable.headlineStatistic.wildfireRiskScenarioTooltip':
    'Risk that is in scope within the area covered by the scenario, which may not be the same as the amount of risk reduced when work is completed. Wildfire risk is calculated by multiplying the likelihood metric (burnability per year) with consequence (value within 0.07 mi). <link>Learn more</link>',
  'programTable.wildfireRiskCalculation':
    'Wildfire risk is calculated by multiplying the likelihood metric (burnability per year) with consequence (value within 0.07 mi).',
  'programTable.headlineStatistic.riskExplanation':
    'of expected vegetation SAIFI',
  'programTable.headlineStatistic.distanceTitle': '{distanceUnit} addressed',
  'programTable.headlineStatistic.distanceExplanation':
    'of total {distanceUnit}',
  'programTable.headlineStatistic.workloadTitle': 'Workload',
  'programTable.headlineStatistic.yearSelectorLabelSuffix': 'plan',
  'programTable.headlineStatistic.workloadExplanation':
    '{distanceUnit} in scope ({formattedQty} total)',
  'programTable.headlineStatistic.encroachmentRatingSuffix': 'Encroachment',
  'programTable.allGroups': 'All planned {groupLabel}',
  'programTable.allGroupsShort': 'All',
  'programTable.year.unknown': 'Unknown',
  'programTable.year.selectYear': 'Select year',
  'programTable.year.notPlanned': 'Not planned',
  'programTable.columnGroup.dataMessage':
    'Metrics based on latest available data for each span.',
  'programTable.columnGroup.plan': 'Plan',
  'planSelector.plans': '{num, plural, one {# scenario} other {# scenarios}}',
  'planSelector.active': 'Active',
  'planStatusBadge.active': 'Active',
  'planStatusBadge.draft': 'Alternate',
  'planStatusBadge.pre-draft': 'Alternate',
  'planStatusBadge.archived': 'Archived',
  'planStatusBadge.tooltip.active':
    'This is the active scenario, ready to operationalize. To edit the scope, duplicate or switch to an alternate.',
  'planStatusBadge.tooltip.draft':
    "This is an alternate scenario, not yet ready to operationalize. Changes won't affect the program until published.",
  'planStatusBadge.tooltip.pre-draft':
    "This is a scenario of your program - not your active plan. Changes here won't affect the current program until published.",
  'planStatusBadge.tooltip.archived':
    'This scenario has been archived and is read-only. To reuse it, unarchive it first.',
  'releaseStatusBadge.draft': 'Draft',
  'releaseStatusBadge.revoked': 'Revoked',
  'releaseStatusBadge.archived': 'Archived',
  'releaseStatusBadge.published': 'Published',
  'releaseStatusBadge.combined': 'Combined',
  'releaseSelector.latest': 'Latest',
  'planSelector.duplicateScenario': 'Duplicate',
  'planSelector.stat.reliabilityRisk': 'Reliability risk',
  'planSelector.stat.workload': 'Workload',
  'planSelector.stat.estimatedCost': 'Estimated cost',
  'programTable.columnGroup.progress': 'Progress',
  'programTable.columnGroup.risk': 'Risk',
  'programTable.columnGroup.risk.tooltip':
    'Priority score is designed to help you prioritize the circuits with the highest number of P1 and P2 spans, given they drive the majority of outages.',
  'programTable.columnGroup.scenario': 'Scenario scope',
  'programTable.columnGroup.network': 'Network',
  'programTable.columnGroup.planExploration': 'Plan exploration',
  'programTable.column.lastWorkYear': 'Last work year',
  'programTable.column.nextWorkYear': 'Next work year',
  'programTable.column.nextTrimDate': 'Next cycle work',
  'programTable.column.expectedInterval.header': 'Expected interval',
  'programTable.column.expectedInterval.yearLabel':
    '{years, plural, one {# yr} other {# yrs}}',
  'programTable.column.targetStart': 'Target start',
  'programTable.column.workStarted': 'Work started',
  'programTable.column.workEnded': 'Work ended',
  'programTable.column.status': 'Status',
  'programTable.column.notes': 'Notes',
  'programTable.column.view': 'View',
  'programTable.column.priority': 'Reliability priority',
  'programTable.column.reliabilityPriority': 'Reliability priority score',
  'programTable.column.reliabilityRisk': 'Reliability risk',
  'programTable.column.wildfireRisk': 'Wildfire risk',
  'programTable.column.contractor': 'Contractor',
  'programTable.column.spanCount': 'Span count',
  'programTable.column.workload': 'Workload',
  'programTable.column.totalDistance': 'Total {distanceUnit}',
  'programTable.column.totalDistance.filterLabel':
    'Filter by total {distanceUnit}',
  'programTable.column.unitName': 'Unit Name',
  'programTable.targetedDistance.header': 'Targeted spans',
  'programTable.targetedDistance.bar.tooltip.enc_rating_5.header':
    'High Encroachment',
  'programTable.targetedDistance.bar.tooltip.enc_rating_4.header':
    'Medium Encroachment',
  'programTable.targetedDistance.bar.tooltip.enc_rating_3.header':
    'Low Encroachment',
  'programTable.targetedDistance.bar.tooltip.enc_rating_2.header':
    'Minor Encroachment',
  'programTable.targetedDistance.bar.tooltip.enc_rating_1.header':
    'None Encroachment',
  'programTable.targetedDistance.bar.tooltip.enc_rating_0.header':
    'Unknown Encroachment',
  'programTable.targetedDistance.tooltip':
    'Targeted {distanceUnit} & enc. risk ratings of those spans',
  'programTable.saveError':
    'There was an error saving your Cycle Schedule updates - please contact your Overstory customer representative if you are still having issues.',
  'programTable.scopeFilter.targetSpans': 'Target spans',
  'programTable.scopeFilter.description':
    'Filter the network to define your program scope',
  'programTable.scopeFilter.emptyTitle': 'No filters have been applied',
  'programTable.scopeFilter.emptyDescription':
    'Add rules to define which spans should be included in scope',
  'programTable.scopeFilter.emptyDescriptionReadOnly':
    'This is a read-only mode. To change your targeted spans, edit this scenario',
  'programTable.scopeFilter.addCondition': 'Add condition',
  'programTable.scopeFilter.footerSpans': '{count} spans',
  'programTable.scopeFilter.targetSpansWhere': 'Target spans where:',
  'programTable.scopeFilter.addGroup': 'Add group',
  'programTable.scopeFilter.ungroup': 'Ungroup',
  'programTable.scopeFilter.fieldPlaceholder': 'Variable name',
  'programTable.scopeFilter.operatorPlaceholder': 'Select',
  'programTable.scopeFilter.valuePlaceholder': 'Select',
  'programTable.scopeFilter.searchFields': 'Search fields',
  'programTable.scopeFilter.valueRequired':
    'Select a value to complete this filter',
  'programTable.scopeFilter.addDisabledTooltip':
    'Finish the current filter before adding another',
  'programTable.scopeFilter.conjunction.and': 'AND',
  'programTable.scopeFilter.conjunction.or': 'OR',
  'programTable.scopeFilter.category.reliability': 'Reliability risk',
  'programTable.scopeFilter.category.wildfire': 'Wildfire',
  'programTable.scopeFilter.category.assets': 'Assets',
  'programTable.scopeFilter.category.encroachment': 'Encroachment',
  'programTable.scopeFilter.category.fallIn': 'Fall-in',
  'programTable.scopeFilter.category.work': 'Work',
  'programTable.scopeFilter.operator.isAnyOf': 'is any of',
  'programTable.scopeFilter.operator.isNoneOf': 'is none of',
  'programTable.scopeFilter.operator.isTrue': 'is true',
  'programTable.scopeFilter.operator.isFalse': 'is false',
  'programTable.scopeFilter.operator.gte': 'is ≥',
  'programTable.scopeFilter.operator.lte': 'is ≤',
  'programTable.scopeFilter.field.network': 'Network',
  'programTable.scopeFilter.field.phasingType': 'Phase system',
  'programTable.scopeFilter.field.voltageInKv': 'Voltage',
  'programTable.scopeFilter.field.priorityRatings': 'Reliability priority',
  'programTable.scopeFilter.field.wildfireRatings': 'Wildfire zone',
  'programTable.scopeFilter.field.wildfirePriorityRatings': 'Wildfire priority',
  'programTable.scopeFilter.field.encroachmentRating': 'Encroachment level',
  'programTable.scopeFilter.field.hasOverhang': 'Has overhang',
  'programTable.scopeFilter.field.criticalTrees': 'Critical tree count',
  'programTable.scopeFilter.field.decliningTrees': 'Declining tree count',
  'programTable.scopeFilter.field.hazardTrees': 'Hazard tree count',
  'programTable.scopeFilter.field.strikeTrees': 'Strike tree count',
  'programTable.scopeFilter.field.species': 'Most common species',
  'programTable.scopeFilter.field.workStatus': 'Work status',
  'programTable.scopeFilter.field.fuelHazardRating': 'Fuel hazard',
  'programTable.columnVisibility.title': 'Show/hide columns',

  'programTable.estimatedCost.header': 'Estimated cost',
  'programTable.estimatedCost.modal.title': 'Cost estimates',
  'programTable.estimatedCost.modal.basisLabel':
    'Estimate based on encroachment risk per',
  'programTable.estimatedCost.modal.encroachmentLevel.subtitle':
    'Estimated cost to work a...',

  'programTable.estimatedCost.modal.suffix.perItem': 'per {item}',
  'programTable.estimatedCost.field.encroachmentRiskSpan':
    '{level} encroachment risk span',
  'programTable.estimatedCost.tooltip':
    'Estimated cost is based on unit cost assumptions.',
  'programTable.estimatedCost.tooltip.settingsLink':
    'View in <link>Program settings</link>.',
  'programTable.estimatedCost.saveSuccess': 'Cost configuration saved',
  'programTable.estimatedCost.saveSuccessMessage':
    'Your cost estimation settings have been updated.',
  'programTable.overview.reliabilityRisk': 'Reliability risk',

  // Program settings
  'program.settings.modal.title': 'Program settings',
  'program.settings.modal.tab.general': 'General',
  'program.settings.modal.tab.costsAssumptions': 'Cost Assumptions',
  'program.settings.details': 'Program details',
  'program.settings.field.name': 'Program name',
  'program.settings.field.name.placeholder': 'Program name',
  'program.settings.field.description': 'Description',
  'program.settings.field.description.placeholder':
    'Capture high-level goals or KPIs to clarify the intent of this program.',
  'program.settings.error.nameRequired': 'Program name cannot be empty',
  'program.settings.error.costRequired': 'Cost cannot be empty',
  'program.settings.saveSuccessMessage': 'Your settings have been updated',
  'program.settings.modal.tab.deleteProgram': 'Delete program',
  'program.settings.confirmDeletion': 'Confirm deletion',
  'program.settings.deleteProgramDescription':
    'Permanently delete this program and all associated scenarios for your team.',
  'program.settings.deleteProgramConfirmMessage':
    'Deleting this program will permanently remove:',
  'program.settings.deleteProgramConfirmMessageEmpty':
    'This will permanently delete the program for your whole team.',
  'program.settings.deleteProgramConfirmBulletScenarios':
    '{count, plural, one {1 scenario} other {{count} scenarios}}',
  'program.settings.deleteProgramConfirmBulletActiveScenario':
    '1 active scenario',
  'program.settings.deleteProgramConfirmBulletAlternateScenarios':
    '{count, plural, one {1 alternate scenario} other {{count} alternate scenarios}}',
  'program.settings.deleteProgram': 'Delete program',
  'program.settings.deleteProgramSuccess': 'Program deleted successfully',

  // All programs
  'program.overview.title': 'Programs',
  'program.breadcrumb.allPrograms': 'All programs',
  'program.breadcrumb.backToAllPrograms': 'Back to all programs',
  'program.create': 'Create program',
  'program.creation.wizard.title': 'Step {step} of {total} - Create program',
  'program.creation.wizard.titleScenario':
    'Step {step} of {total} - Create scenario',
  'scenario.create.modalTitle': 'Create scenario',
  'scenario.create.populationMethod.title':
    'How do you want to populate next work year for this scenario?',
  'scenario.create.populationMethod.fromCsv': 'Upload from CSV',
  'scenario.create.populationMethod.fromCsvDescription':
    "Import 'next work year' per planning group from a spreadsheet. Best for large programs.",
  'scenario.create.populationMethod.fromProduct': 'Select in product',
  'scenario.create.populationMethod.fromProductDescription':
    "Manually assign 'next work year' per circuit using the scenario table.",
  'scenario.create.csv.title': 'Upload CSV',
  'scenario.create.csv.subtitle':
    "Create a scenario with pre-populated 'next work year' fields from your file.",
  'scenario.create.csv.fileRejected': 'Unsupported file. Upload a CSV file.',
  'scenario.create.csv.fileTooLarge':
    'File is too large. Maximum size is 10 MB.',
  'scenario.create.csv.dropzoneIdle': 'Drag and drop CSV here',
  'scenario.create.csv.browseFiles': 'Browse files',
  'scenario.create.csv.replaceFile': 'Replace file',
  'scenario.create.csv.errorTitle': 'Fix errors and re-upload CSV',
  'scenario.create.csv.removeFile': 'Remove file',
  'scenario.create.csv.requirementsTitle': 'CSV requirements:',
  'scenario.create.csv.req1Title':
    'Upload one CSV with 2 columns that match the names:',
  'scenario.create.csv.req1Col1': 'Column 1: planning_group',
  'scenario.create.csv.req1Col2': 'Column 2: next_trim_year',
  'scenario.create.csv.req2':
    'All planning_group fields in the CSV must exactly match the Overstory planning group names',
  'scenario.create.csv.req3':
    'Any missing fields will be populated blank in the scenario',
  'program.overview.statsByGroup': '{year} {groupLabel}',
  'program.overview.stats.reliabilityRisk': 'Reliability risk',
  'program.overview.stats.workload': 'Workload',
  'program.overview.stats.estimatedCost': 'Estimated cost',
  'program.overview.stats.wildfireRisk': 'Wildfire risk',
  'program.overview.stats.perYear': '/year',
  'program.overview.stats.wildfireRisk.secondaryValue':
    '{pct}% of network risk',
  'exploration.yearSwitcher.suffix': 'scope',
  'exploration.yearSwitcher.allYears': 'All planned years',
  'exploration.yearSwitcher.metricsFor': 'Metrics for',

  // Plans
  'plan.createNewPlan': 'Create new scenario',
  'plan.copyOfName': 'Copy of {name}',
  'plan.newScenarioDefaultName': 'Untitled scenario',
  'plan.editNameAndDescription': 'Edit name and description',
  'plan.editScenario': 'Edit',
  'plan.editDisabledTooltip.onlyActive':
    'The active scenario is ready to be operationalized and cannot be edited. To edit the scope, duplicate this scenario.',
  'plan.editDisabledTooltip.withAlternates':
    'The active scenario is ready to be operationalized and cannot be edited. To edit the scope, duplicate or switch to an alternate.',
  'plan.draftEdit.header.title': "Editing ''{planTitle}''",
  'plan.draft.modal.title': 'Plan settings',
  'scenario.settings.modal.title': 'Scenario settings',
  'plan.draft.modal.description': 'Save your current changes as a draft',
  'plan.draft.modal.field.name': 'Plan name',
  'plan.draft.modal.field.name.placeholder': 'e.g. Cost-optimized approach',
  'plan.draft.modal.field.description': 'Plan description',
  'plan.draft.modal.field.description.placeholder':
    'e.g. Exploring what happens if we prioritize circuits with highest SAIDI impact while staying under $1.5M budget...',
  'plan.draft.modal.field.helpText':
    'This draft will be visible to anyone with access to the {programName}.',

  'plan.draft.banner.title': 'Draft plan',
  'plan.draft.banner.description':
    "This is a draft plan, not the active program. Changes here won't affect the current program until published.",
  'scenario.settings.name.error.nameRequired': 'Scenario name cannot be empty',
  'plan.publish.modal.title': 'Publish as the active scenario',
  'plan.publish.modal.title.active': 'Publish scenario as the active scenario',
  'plan.publish': 'Publish',
  'plan.publish.successMessage': 'Scenario has been published successfully',
  'plan.unpublish.successMessage': 'Scenario has been unpublished successfully',
  'plan.archive.successMessage': 'Scenario has been archived successfully',
  'plan.unarchive.successMessage': 'Scenario has been unarchived successfully',
  'plan.notFound': 'This scenario could not be found.',
  'plan.unpublish.modal.title': "Unpublish ''{planName}''?",
  'plan.unpublish.modal.heading':
    "You will no longer have an active scenario in your program, ''{programName}.''",
  'plan.unpublish.modal.point1':
    'Your program will no longer have an active source of truth.',
  'plan.unpublish.modal.point2':
    "You will still be able to access ''{planName}'' as a scenario in your program.",
  'plan.unpublish.modal.point3': 'You can republish your scenario at any time.',
  'plan.publish.modal.heading':
    "''{planName}'' will become the active scenario for ''{programName}''. This will mark it as ready to operationalize.",
  'plan.publish.modal.heading.active':
    "''{planName}'' will replace the current active scenario for ''{programName}'' and mark it as ready to operationalize.",
  'plan.headlineStatistic.workloadExplanation': 'in scope',
  'plan.headlineStatistic.workloadOfNetwork': '{pct}% of network',

  // All plans
  'plan.active': 'Active plan',
  'plan.draft': 'Alternate scenarios',
  'plan.archived': 'Archived scenarios',
  'plan.overview.empty': 'No plans available for this program.',
  'plan.overview.empty.title': 'Model scenarios in this program',
  'plan.overview.empty.description1':
    'A scenario is one possible scope of work for your program, where you can define which spans to work, and in which year.',
  'plan.overview.empty.description2':
    "Draft multiple scenarios to compare reliability risk, workload, and estimated cost side by side, then publish the one you'll execute.",
  'plan.alternative': 'Alternative plans',
  'program.overview.noActivePlan': 'Publish a scenario to see program metrics',
  'program.reliabilityMetric.outages': 'outages',
  'program.reliabilityMetric.ci': 'CI',
  'program.reliabilityMetric.cmi': 'CMI',
  'program.reliabilityMetric.headline.outages': 'Outages',
  'program.reliabilityMetric.headline.ci': 'CI',
  'program.reliabilityMetric.headline.cmi': 'CMI',
  'program.reliabilityMetric.networkRiskPct': '{pct}% of network risk',
  'program.reliabilityMetric.networkSaifiPct': '{pct}% network SAIFI',
  'program.reliabilityMetric.label.relative': 'Network SAIFI',
  'program.reliabilityMetric.scannedNetworkSaifi': 'scanned network SAIFI',
  'program.reliabilityMetric.label.outages': 'Outages in scope',
  'program.reliabilityMetric.label.ci': 'CI in scope',
  'program.reliabilityMetric.label.cmi': 'CMI in scope',
  'program.reliabilityMetric.tooltip':
    'Risk that is present within the spans included in this scenario in the chosen year, which may not be the same as the amount of risk reduced when work is completed. Reliability risk metrics are based on encroachment level and phasing on distribution lines.',
  'program.reliabilityMetric.networkTooltip':
    'Reliability risk for a given network group is based on encroachment level and phasing on distribution lines.',
  'program.reliabilityMetric.programAbsoluteMetricsTooltip':
    'Risk that is present within the spans included in this program for the chosen year, which may not be the same as the amount of risk reduced when work is completed. Reliability risk metrics are based on encroachment level and phasing on distribution lines.',
  'program.overview.empty.title': 'Find your Programs here',
  'program.overview.empty.description':
    'Use Programs to store all active vegetation work, design different scenarios, and weigh tradeoffs between costs and risk addressed.',
  'program.overview.empty.csmHelp':
    'Not sure where to start? Contact your Customer Success Manager to help you build your first program.',
  'program.overview.empty.learnMore': 'Learn more in our help article.',

  // Red Flag Warnings
  'redFlagWarning.errorLoading': 'Error loading Red Flag Warnings',
  'redFlagWarning.title': 'Red Flag Warnings',
  'redFlagWarning.close': 'Close',
  'redFlagWarning.showAffectedSpans': 'Show affected spans',
  'redFlagWarning.noWarningsTitle':
    'No Red Flag Warnings in or near your network',
  'redFlagWarning.noWarningsBody':
    'When Red Flag Warnings are active, check affected spans across your network to quickly see where wildfire risk is elevated. No external maps or codes needed.',
  'programTable.yearChange.confirmTitle':
    'Are you sure you want to make this change?',
  'programTable.yearChange.confirmContent':
    '{fieldName} for {circuitName} changed from {prevYear} to {newYear}',
  'programTable.yearChange.confirmButton': 'Confirm change',

  'groupSummary.riskMetrics.title': 'Risk metrics',
  'groupSummary.riskMetrics.riskPerYear': 'Risk / year',
  'groupSummary.riskMetrics.burnabilityPerYear': 'Burnability / year',
  'groupSummary.riskMetrics.valueWithinRadius': 'Value within 0.07 mi',
  'groupSummary.riskMetrics.helpText':
    'Risk is calculated by multiplying the likelihood metric (burnability per year) with consequence (value within 0.07 mi).',
  'groupSummary.fuelDistribution.title': 'Fuel distribution',
  'groupSummary.fuelDistribution.empty': 'No fuel data available.',
  'level3.fuelHazard.title': 'Fuel hazard',
  'level3.fuelHazard.tooltip':
    'Fuel hazard displays both a relative hazard level for your network (Ex: high, medium, low), and an absolute score out of 1. Fuel hazard is based on 30cm vegetation imagery, and accounts for base fire intensity as well as fuel diversity, adjacency, and continuity.',
  'level3.workType.title': 'Work type analysis',
  'level3.workType.byArea': 'By area',
  'level3.workType.linearExtent': 'Linear extent',
  'level3.workType.unit.sqft': '{value} sq ft',
  'level3.workType.unit.sqm': '{value} m²',
  'workType.herbicide': 'Herbicide',
  'workType.mow': 'Mow',
  'workType.cut': 'Cut',
  'workType.sideWall': 'Side-wall',
  'workType.noWorkType': 'No work type',
  'fuelCategory.grass': 'Grass',
  'fuelCategory.shrub': 'Shrub',
  'fuelCategory.timber_litter': 'Timber litter',
  'fuelCategory.slash_blowdown': 'Slash & blowdown',
  'fuelCategory.non_burnable': 'Non-burnable',
  'filter.fuelDistribution.title': 'Fuel distribution',
  'filter.fuelDistribution.noConstraint': 'No constraint',
  'fuelDistribution.percentLessThan': 'Less than {value}%',
  'filter.fuelHazardRating.title': 'Spread potential',
  'filter.fuelHazardRating.allRatings': 'All ratings',
  'reliabilityConfig.title': 'Reliability data configuration',
  'reliabilityConfig.section.sourceInfo': 'Source info',
  'reliabilityConfig.section.outageData': 'Vegetation outage data',
  'reliabilityConfig.section.outageData.helper':
    'Total vegetation outage count is automatically calculated from the encroachment and fall-in counts below.',
  'reliabilityConfig.section.customerInterruption':
    'Customer interruption data',
  'reliabilityConfig.section.customerInterruption.helper':
    'Total customer minutes of interruption (CMI) is automatically calculated from the encroachment and fall-in values below.',
  'reliabilityConfig.section.customerImpact': 'Customer impact',
  'reliabilityConfig.section.customerImpact.helper':
    "Customer counts are used to convert outage data into customer-weighted impact metrics. Use Overstory's defaults or manually enter your network's average customer counts per phasing type.",
  'reliabilityConfig.field.primaryMetric': 'Default reliability metric',
  'reliabilityConfig.field.dataSourceName': 'Data source name',
  'reliabilityConfig.field.timePeriod': 'Time period',
  'reliabilityConfig.field.overheadLineLength':
    'Total overhead distribution line-{distanceUnit} represented by this source data',
  'reliabilityConfig.field.description': 'Description (optional)',
  'reliabilityConfig.field.encRelatedOutages': 'Outage count from encroachment',
  'reliabilityConfig.field.fallinRelatedOutages': 'Outage count from fall-in',
  'reliabilityConfig.field.totalOutages': 'Total vegetation outage count',
  'reliabilityConfig.field.encRelatedCmi':
    'Customer minutes of interruption from encroachment',
  'reliabilityConfig.field.fallinRelatedCmi':
    'Customer minutes of interruption from fall-in',
  'reliabilityConfig.field.totalCmi': 'Total customer minutes of interruption',
  'reliabilityConfig.field.totalCiInstances':
    'Total customer interruption (CI) instances',
  'reliabilityConfig.field.singlePhase':
    'Average customer count — single phase',
  'reliabilityConfig.field.twoPhase': 'Average customer count — two-phase',
  'reliabilityConfig.field.threePhase': 'Average customer count — three-phase',
  'reliabilityConfig.primaryMetric.absoluteOutages': 'Outages',
  'reliabilityConfig.primaryMetric.absoluteCi': 'CI',
  'reliabilityConfig.primaryMetric.absoluteCmi': 'CMI',
  'reliabilityConfig.placeholder.dataSourceName':
    'e.g. outage-network-2025-Q1.csv',
  'reliabilityConfig.placeholder.timePeriod': 'Select a date range',
  'reliabilityConfig.placeholder.overheadLines': 'Ex: 12,500',
  'reliabilityConfig.placeholder.description': 'add description here',
  'reliabilityConfig.placeholder.encRelatedOutages': 'Ex: 32',
  'reliabilityConfig.placeholder.fallinRelatedOutages': 'Ex: 28',
  'reliabilityConfig.placeholder.encRelatedCmi': 'Ex: 18,420',
  'reliabilityConfig.placeholder.fallinRelatedCmi': 'Ex: 12,950',
  'reliabilityConfig.placeholder.ciInstances': 'Ex: 4,560',
  'reliabilityConfig.placeholder.singlePhase': 'Ex: 28',
  'reliabilityConfig.placeholder.twoPhase': 'Ex: 42',
  'reliabilityConfig.placeholder.threePhase': 'Ex: 65',
  'reliabilityConfig.customerImpact.useDefaults':
    'Use Overstory default customer impact numbers',
  'reliabilityConfig.customerImpact.useDefaults.hint':
    'Uses industry-average customer counts per phasing.',
  'reliabilityConfig.customerImpact.manual':
    'Manually enter average customer counts per phasing',
  'reliabilityConfig.customerImpact.manual.hint':
    "Use your network's own customer counts for each phasing type.",
  'reliabilityConfig.save.success': 'Reliability metrics configuration saved.',
  'reliabilityConfig.save.error':
    'Failed to save configuration. Please try again.',
  'reliabilityConfig.cancelDialog.title': 'Cancel changes?',
  'reliabilityConfig.cancelDialog.message':
    "Any updates you've made to the configuration will be lost.",
  'reliabilityConfig.emptyState': 'Pick a client to get started.',
  'vegetationIntelligence.addressed': 'Addressed',
  'vegetationIntelligence.addressedShare': '{name} addressed',
  'vegetationIntelligence.addressedSpans': 'Addressed spans',
  'vegetationIntelligence.allCircuits': 'All circuits',
  'vegetationIntelligence.allDistricts': 'All districts',
  'vegetationIntelligence.circuitCount':
    '{count, plural, one {# circuit} other {# circuits}}',
  'vegetationIntelligence.circuits': 'Circuits',
  'vegetationIntelligence.districtCount':
    '{count, plural, one {# district} other {# districts}}',
  'vegetationIntelligence.districts': 'Districts',
  'vegetationIntelligence.lineMiles': 'Line miles',
  'vegetationIntelligence.lineMilesByProgram':
    'Addressed line miles by program',
  'vegetationIntelligence.navLabel': 'Vegetation',
  'vegetationIntelligence.network': 'Network',
  'vegetationIntelligence.noProgram': 'No program',
  'vegetationIntelligence.riskUnderManagement': 'Risk under management',
  'vegetationIntelligence.sort': 'Sort',
  'vegetationIntelligence.sortMilesAddressed': 'Sort: Line miles addressed',
  'vegetationIntelligence.sortMilesUnaddressed': 'Sort: Line miles unaddressed',
  'vegetationIntelligence.spans': 'Spans',
  'vegetationIntelligence.unaddressed': 'Unaddressed',
  'vegetationIntelligence.unaddressedRisk': 'Unaddressed risk',
};

export type MessageId = keyof typeof en_US;

export default en_US;
